//import "select2";
import angular from "angular";
import uiSelect from "angular-ui-select/select.js";
import dcSelect from "./dc-select";
import dcSelectMulti from "./dc-select-multi";
import "./dc-select.less";
import "../../../less/styles.less";

export default angular.module("dc-ui.dcSelect",["ui.select"])
  .directive("dcSelect",dcSelect)
  .directive("dcSelectMulti",dcSelectMulti)
  .name;



// WEBPACK FOOTER //
// ./src/ui/modules/dc-ui/dc-select/index.js